var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.sector === 'countries')?_c('countries-chart',{staticClass:"main-window",attrs:{"data":_vm.data,"sorted-by":_vm.sortedBy},on:{"timeFrame":_vm.emitTimeFrame}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }